import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Container, CardWrapper } from "./key-features.cards.style"

export default function Cards({ isVisible, disableAnimations }) {
  const query = useStaticQuery(graphql`
    query {
      iconDigitize: allFile(
        filter: { relativePath: { eq: "0_HOMEPAGE/Icons/digitize_icon.svg" } }
      ) {
        edges {
          node {
            publicURL
          }
        }
      }
      iconEditor: allFile(
        filter: { relativePath: { eq: "0_HOMEPAGE/Icons/editor_icon.svg" } }
      ) {
        edges {
          node {
            publicURL
          }
        }
      }
      iconInsights: allFile(
        filter: { relativePath: { eq: "0_HOMEPAGE/Icons/insights_icon.svg" } }
      ) {
        edges {
          node {
            publicURL
          }
        }
      }
      iconSdk: allFile(
        filter: { relativePath: { eq: "0_HOMEPAGE/Icons/sdk_icon.svg" } }
      ) {
        edges {
          node {
            publicURL
          }
        }
      }
    }
  `)

  const { iconDigitize, iconEditor, iconInsights, iconSdk } = Object.keys(
    query
  ).reduce((acc, key) => {
    acc[key] = query[key].edges[0].node.publicURL
    return acc
  }, [])

  return (
    <Container isVisible={isVisible} disableAnimations={disableAnimations}>
      <Card
        iconSrc={iconDigitize}
        alt="Map Digitization - Folded Map Icon"
        title="Digitization"
        description="Generate a digital asset from your 2D map, including all geometry and data."
      />
      <Card
        iconSrc={iconSdk}
        alt="Mapping SDKs - Hammer Icon"
        title="SDKs & Exports"
        description="Bring your vision to life using our SDKs, with sample applications and integrations."
      />
      <Card
        iconSrc={iconEditor}
        alt="Map Editor - Mouse Pointer Icon"
        title="Editor Tools"
        description="Make geometry and data changes in real-time, ensuring your map is always up to date."
      />
      <Card
        iconSrc={iconInsights}
        alt="Map Editor - Bar Chart Icon"
        title="Data & Insights"
        description="Leverage our dashboards and APIs to gather valuable insights from your mapping solution."
      />
    </Container>
  )
}

const Card = ({ iconSrc, title, description, alt = "" }) => {
  return (
    <CardWrapper>
      <div>
        <img src={iconSrc} alt={alt} />
        <h3>{title}</h3>
      </div>
      <p>{description}</p>
    </CardWrapper>
  )
}
